import JSRouter from "adminPage/JSRouter";
import Modal from "modal/Modal";
import Ajax from "base/Ajax";

JSRouter.register('reset', '/', () => {

    class ResetEverythingModal extends Modal {
        constructor() {
            super({
                "class": "modal--confirm",
                "closeButton": false,
                "backgroundClose": false,
                "escClose": false
            });
            let $content = (
                eotwJSXFactory('div', null, [
                    eotwJSXFactory('h2', null, ["Are you sure?"]),
                    eotwJSXFactory('span', {class: "admin-modal--confirm__text"}, ["Are you sure you want to delete everything?"]),

                    eotwJSXFactory('div', {class: "admin-form"}, [
                        eotwJSXFactory('div', {class: "admin-form__row"}, [
                            eotwJSXFactory('label', {class: "admin-form__label", for: "password"}, ["Password"]),
                            eotwJSXFactory('input', {type: "password", class: "admin-form__input js-password", id: "password"})
                        ])
                    ]),

                    eotwJSXFactory('div', {class: "admin-modal__buttons"}, [
                        eotwJSXFactory('button', {class: "admin-btn admin-btn--confirm admin-btn--modal"}, ["Yes"]).on("click", function () {
                            if ($(this).is(".admin-btn--loading")) return false;
                            $(this).addClass("admin-btn--loading");
                            Ajax.delete("reset", "reset-everything", {password: $content.find(".js-password").val()}).then(() => {
                                window.location.href = window.CONFIG.urls.admin;
                            }).catch((e) => {
                                $(this).removeClass("admin-btn--loading");
                                alert(e.message);
                            });
                            return false;
                        }),
                        eotwJSXFactory('button', {class: "admin-btn admin-btn--cancel admin-btn--modal"}, ["Cancel"]).on("click", () => {
                            window.location.href = window.CONFIG.urls.website;
                        })
                    ])
                ])
            );

            this.setContent($content);
        }
    }

    $("body").on("click", ".js-reset-sitemanager", () => {
        let modal = new ResetEverythingModal();
        modal.show();

        return false;
    })

});
